export default __webpack_public_path__ + "static/CircularXXWeb-Book-f1485158ed1f15d8ddf2c606d6e21d74.woff";